import { useState } from 'react';
import Button from '@raydiant/raydial/components/Button';
import Modal from '@raydiant/raydial/components/Modal';
import TextField from '@raydiant/raydial/components/TextField';
import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import { Content } from '@raydiant/api-client-js';

interface RenameContentDialogProps {
  content: Content;
  isLoading: boolean;
  isOpen: boolean;
  onSubmit: (name: string) => void;
  onClose: () => void;
}

const RenameContentDialog = ({
  content,
  isLoading,
  isOpen = false,
  onSubmit,
  onClose,
}: RenameContentDialogProps) => {
  const [name, setName] = useState<string>(content.name);

  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog showCloseButton onClose={() => onClose()}>
        <DialogHeader>
          <DialogHeading>
            <span className="text-black">Rename {content.resourceType}</span>
          </DialogHeading>
        </DialogHeader>

        <TextField
          value={name || ''}
          onChange={setName}
          placeholder={`Enter ${content.resourceType} name`}
        />

        <div className="flex flex-col-reverse justify-between mt-8 mb-4 gap-3 px-0 md:gap-6 md:flex-row md:px-4">
          <Button
            onPress={() => onClose()}
            variant="secondary"
            size="large"
            className="grow"
          >
            Cancel
          </Button>
          <Button
            loading={isLoading}
            isDisabled={isLoading || !name}
            onPress={() => onSubmit(name)}
            variant="primary"
            size="large"
            className="grow"
          >
            Done
          </Button>
        </div>
      </Dialog>
    </Modal>
  );
};

export default RenameContentDialog;
